<script>
    // Import axios for API consuming in a clean interface.
    import axios from 'axios';

    // Import animated counter component
    import Vue3Autocounter from 'vue3-autocounter';

    export default {
        components: {
            Vue3Autocounter,
        },
        props: {
            filterItems: Array,
        },
        data() {
            return {
                loading: false,
                limit: 0,
                offset: 0,
                amountArrangements: 0,
                amountDeductions: 0,
            }
        },
        async created() {
            this.loading = true;

            try {
                const api = this.$store.getters.getText('dashboardApiEndpointArrangements');

                const response = await axios.post(
                    api,
                    {
                        Limit: this.limit,
                        Offset: this.offset,
                        Text: '',
                        FilterItems: this.filterItems,
                    }
                );
                if (!response || response.status != 200 || !response.data) throw 'no response or bad status';
                this.amountArrangements = response.data.queryCount;
            } catch (error) {
                console.error('Error loading JSON data: ', error);
            }

            try {
                const api = this.$store.getters.getText('dashboardApiEndpointDeductions');

                const response = await axios.post(
                    api,
                    {
                        Limit: this.limit,
                        Offset: this.offset,
                        Text: '',
                        FilterItems: this.filterItems,
                    }
                );
                if (!response || response.status != 200 || !response.data) throw 'no response or bad status';
                this.amountDeductions = response.data.queryCount;
            } catch (error) {
                console.error('Error loading JSON data: ', error);
            }

            this.loading = false;
        },
    };
</script>

<template>
    <div v-if="loading" class="has-text-centered">
        <div class="lds-facebook has-text-grey-lighter">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div v-else class="dashboard-widget">
        <div class="block has-text-centered pt-2">
            <span class="is-size-10 has-text-weight-bold">{{ $store.getters.getText('dashboardWidgetArrangementsdeductions') }}</span>
        </div>
        <div class="block is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardTabArrangements') }}</span>
            <vue3-autocounter :endAmount="amountArrangements" separator="." duration="0.5" />
        </div>
        <div class="block is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardTabDeductions') }}</span>
            <vue3-autocounter :endAmount="amountDeductions" separator="." duration="0.5" />
        </div>
    </div>
</template>
